import { type ContentPromotionImageShade, type Maybe } from '../../../__generated__/graphql-client-types';
import { NON_BREAKING_SPACE } from '../../../constants/general';

export const getBackgroundStyle = (imageShade: Maybe<ContentPromotionImageShade>, backgroundUrl: string) => {
	const baseBackground = `url(${backgroundUrl}) no-repeat center center`;

	switch (imageShade) {
		case 'DARK':
			return {
				background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), ${baseBackground}`,
				boxShadow: 'inset 0 0 0 1000px rgba(0, 0, 0, 0.3)'
			};
		case 'LIGHT':
			return {
				background: baseBackground,
				boxShadow: 'inset 0 0 0 1000px rgba(255, 255, 255, 0.7)'
			};
		case 'NONE':
		default:
			return {
				background: baseBackground
			};
	}
};

export const defaultCouponExpirationString = (couponCode: Maybe<string>, expirationDate: Maybe<string>): string => {
	const couponText = couponCode ? `COUPON:${NON_BREAKING_SPACE}${couponCode}` : '';
	const expDateText = expirationDate ? `Exp.${NON_BREAKING_SPACE}${expirationDate}` : '';
	return `${couponText}${couponText && expDateText ? ' ' : ''}${expDateText}`;
};
